export const getRightInvocationEmptyIdentityValue = () => ({ code: '', value: '' })
